import type { PictureProfile } from '~/Partials/Picture/Picture';

export class PictureProfiles {
    static readonly threeOfTwelveColumnsElementHorizontal: PictureProfile = {
        defaultWidth: 500,
        sources: [
            {
                allowedWidths: [175, 375, 500, 768],
                sizes: ['(min-width: 1440px) 375px', '(min-width: 768px) 25vw', '100vw'],
            },
        ],
    };

    static readonly threeOfTwelveColumnsElementVertical: PictureProfile = {
        defaultWidth: 500,
        sources: [
            {
                allowedWidths: [175, 375, 500, 768],
                sizes: ['(min-width: 768px) 33vw', '100vw'],
            },
        ],
    };

    static readonly fourOfTwelveColumnsElementHorizontal: PictureProfile = {
        defaultWidth: 500,
        sources: [
            {
                allowedWidths: [375, 500, 768],
                sizes: ['(min-width: 1440px) 500px', '(min-width: 768px) 33vw', '100vw'],
            },
        ],
    };

    static readonly fourOfTwelveColumnsElementVertical: PictureProfile = {
        defaultWidth: 500,
        sources: [
            {
                allowedWidths: [375, 500, 768],
                sizes: ['(min-width: 768px) 45vw', '100vw'],
            },
        ],
    };

    static readonly fiveOfTwelveColumnsElementHorizontal: PictureProfile = {
        defaultWidth: 500,
        sources: [
            {
                allowedWidths: [375, 500, 768],
                sizes: ['(min-width: 768px) 45vw', '100vw'],
            },
        ],
    };

    static readonly fiveOfTwelveColumnsElementVertical: PictureProfile = {
        defaultWidth: 500,
        sources: [
            {
                allowedWidths: [375, 500, 768],
                sizes: ['(min-width: 768px) 50vw', '100vw'],
            },
        ],
    };

    static readonly sixOfTwelveColumnsElementHorizontal: PictureProfile = {
        defaultWidth: 500,
        sources: [
            {
                allowedWidths: [375, 500, 768, 1024],
                sizes: ['(min-width: 1440px) 768px', '(min-width: 768px) 50vw', '100vw'],
            },
        ],
    };

    static readonly sixOfTwelveColumnsElementVertical: PictureProfile = {
        defaultWidth: 500,
        sources: [
            {
                allowedWidths: [375, 500, 768, 1024],
                sizes: ['(min-width: 768px) 66vw', '100vw'],
            },
        ],
    };

    static readonly eightOfTwelveColumnsElementHorizontal: PictureProfile = {
        defaultWidth: 500,
        sources: [
            {
                allowedWidths: [375, 500, 768, 1024],
                sizes: ['(min-width: 768px) 66vw', '100vw'],
            },
        ],
    };

    static readonly eightOfTwelveColumnsElementVertical: PictureProfile = {
        defaultWidth: 500,
        sources: [
            {
                allowedWidths: [375, 500, 768, 1024],
                sizes: ['(min-width: 768px) 75vw', '100vw'],
            },
        ],
    };

    static readonly fullWidth: PictureProfile = {
        defaultWidth: 1440,
        sources: [
            {
                allowedWidths: [375, 480, 640, 768, 1024, 1440, 1920],
                sizes: ['100vw'],
            },
        ],
    };

    static readonly horizontal: PictureProfile = {
        defaultWidth: 1440,
        sources: [
            {
                allowedWidths: [375, 768, 1440],
                sizes: ['(min-width: 1440px) 1440px', '100vw'],
            },
        ],
    };

    static readonly vertical: PictureProfile = {
        defaultWidth: 552,
        sources: [
            {
                allowedWidths: [375, 552, 768, 1536],
                sizes: ['(max-width: 767px) 100vw', '(min-width: 768px) 552px'],
            },
        ],
    };

    static readonly callout: PictureProfile = {
        defaultWidth: 258,
        sources: [
            {
                allowedWidths: [120, 258],
                sizes: ['(max-width: 767px) 100vw', '(min-width: 768) 120px'],
            },
        ],
    };

    static readonly contentCard: PictureProfile = {
        defaultWidth: 1136,
        sources: [
            {
                allowedWidths: [375, 768, 1136],
                sizes: ['(min-width: 1024px) 1136px', '(min-width: 768px) 768px', '100vw'],
            },
        ],
    };

    static readonly studyPortfolioItem: PictureProfile = {
        defaultWidth: 675,
        sources: [
            {
                allowedWidths: [260, 340, 410, 560, 675, 710, 810, 870],
                sizes: ['(max-width: 767px) 90vw', '(min-width: 768px) 45vw'],
            },
        ],
    };

    static readonly galleryItemSquare: PictureProfile = {
        defaultWidth: 500,
        sources: [
            {
                allowedWidths: [300, 500, 640],
                sizes: ['(min-width: 768px) 640px', '(min-width: 476px) 500px', '300px'],
            },
        ],
    };

    static readonly galleryItemVertical: PictureProfile = {
        defaultWidth: 500,
        sources: [
            {
                allowedWidths: [500, 640],
                sizes: ['(max-width: 767px) 100vw', '(min-width: 768px) 500px'],
            },
        ],
    };

    static readonly galleryItemHorizontal: PictureProfile = {
        defaultWidth: 640,
        sources: [
            {
                allowedWidths: [500, 640, 768],
                sizes: ['(max-width: 767px) 80vw', '(min-width: 768px) 768px'],
            },
        ],
    };

    static readonly mainPosterVertical: PictureProfile = {
        defaultWidth: 500,
        sources: [
            {
                allowedWidths: [500, 768, 1024, 1300],
                sizes: ['(min-width: 768px) 70vw', '100vw'],
            },
        ],
    };
}
